import React from "react";

const spacerVariants = {
	small: "10px",
	medium: "20px",
	large: "40px",
} as const;

type SpacerProps = {
	// eslint-disable-next-line @typescript-eslint/ban-types
	variant: keyof typeof spacerVariants | (string & {});
};

export const Spacer = (props: SpacerProps) => {
	return (
		<div
			className="addtocart-popup__spacer"
			style={{
				marginTop: spacerVariants[props.variant] || props.variant,
			}}
		/>
	);
};
